
class FacetStore {

    constructor() {
        this.state = {
            selectedTerminologieIds: [],
            facetsByTerminologyId: new Map(),
            isLoading: false
        };
    }

 
    /**
     * Génère une Map contenant la configuration des facettes par terminologyId
     * @param {Object} config - Configuration complète depuis l'API
     * @returns {Map<string, Array>} - Map avec terminologyId comme clé et tableau d'entries comme valeur
     */
    generateFacetsMap(config) {
        const facetsMap = new Map();
        if (Array.isArray(config.facets)) {
            for (const facetConfig of config.facets) {
                if (facetConfig.terminologyId && facetConfig.entries) {
                    facetsMap.set(facetConfig.terminologyId, facetConfig.entries);
                }
            }
        }
        return facetsMap;
    }

    /**
     * Récupère les facettes pour une terminologie spécifique
     * @param {string} terminologyId - ID de la terminologie
     * @returns {Array} - Tableau des facettes configurées pour cette terminologie
     */
    getFacetsForTerminology(terminologyId) {
        return this.state.facetsByTerminologyId.get(terminologyId) || [];
    }

    /**
     * Vérifie si une terminologie a des facettes configurées
     * @param {string} terminologyId - ID de la terminologie
     * @returns {boolean}
     */
    hasFacets(terminologyId) {
        return this.state.facetsByTerminologyId.has(terminologyId) && 
               this.state.facetsByTerminologyId.get(terminologyId).length > 0;
    }
}

export default new FacetStore();
